import React from 'react'
import {
  List,
  useListRepository,
  useFilter,
  Filter,
  DatePicker
} from 'elentari'
import MetasAnalistaRepository from './MetasAnalistaRepository'
import { useAbility } from '../../Usuarios'
import { getListActions } from '../../../lib/crudAuthorization'
import moment from 'moment'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'

const MetasAnalistaFilter = () => {
  const filter = useFilter({})

  const handleSubmit = values => {
    return filter.onSubmit({
      ...values,
      data: moment(values.data).format('YYYY-MM-DD')
    })
  }

  return (
    <Filter
      {...filter}
      onSubmit={handleSubmit}
      labels={{ find: 'Buscar', clear: 'Limpar' }}
    >
      <Grid container spacing={3}>
        <Grid item sm={4} xs={6}>
          <Field fullWidth component={DatePicker} label="Data" name="data" />
        </Grid>
      </Grid>
    </Filter>
  )
}

export default function MetasAnalista(props) {
  const [ability] = useAbility()
  const listOptions = {
    defaultOrder: 'data desc',
    fields: {
      id: {
        label: 'Id'
      },
      data: {
        label: 'Data',
        format: data => moment(data).format('DD/MM/YYYY')
      },
      metaSolicitacoes: {
        label: 'Meta de Solicitações'
      }
    }
  }
  const listHook = useListRepository({
    repository: MetasAnalistaRepository,
    path: 'metas',
    defaultSort: 'data desc'
  })
  listHook.onClickEdit = props.onClickEdit
  listHook.onClickNew = props.onClickNew
  const actions = getListActions(ability, listHook, 'metas')
  return (
    <>
      <MetasAnalistaFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
    </>
  )
}
